<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <h2>Demandas de Monitoramento</h2>
  </div>
  <div class="col-lg-2"></div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content box-content">

          <div class="open-filters" *ngIf="!filterActive">
            <button class="btn-filters-close" type="button" (click)="filterActive = true">
              <img src="assets/images/svgs/Filtros.svg">
            </button>
          </div>

          <div *ngIf="filterActive" [@slideIn]="filterActive">
            <div class="form_search">
              <div class="m-b">
                <div class="form-group form-filter">
                  <h3>Filtros</h3>
                  <div class="col-8 d-flex justify-content-end">
                    <button class="btn-filters" type="button" (click)="cleanSearch()">
                      <img src="assets/images/svgs/Limpar_filtros.svg">
                      <span>Limpar Filtros</span>
                    </button>
                    <button class="btn-filters-close" type="button" (click)="filterActive = false">
                      <img src="assets/images/svgs/Fechar.svg" alt="Pesquisar">
                    </button>
                  </div>
                </div>
              </div>

              <form [formGroup]="form">
                <div class="form-group row">
                  <div class="col-sm-4 m-b">
                    <label class="col-sm-12 pb-1">Órgão demandado</label>
                    <ng-select id="filter_agency" class="ng-select-alternative" [items]="list?.orgaos" [multiple]="true" bindLabel="str_nome" bindValue="num_codigo_pk" placeholder="Todos os Órgãos Demandados" formControlName="filter_agency">
                    </ng-select>
                  </div>
                  <div class="col-sm-4 m-b">
                    <label class="col-sm-12 pb-1">Andamento</label>
                    <ng-select id="filter_issue_sub_stat_id" class="ng-select-alternative" [items]="list?.andamentoList" [multiple]="true" bindLabel="label" bindValue="id" placeholder="Todos os Andamentos" formControlName="filter_issue_sub_stat_id">
                    </ng-select>
                  </div>
                  <div class="col-sm-4 m-b">
                    <label class="col-sm-12 pb-1">Demandado</label>
                    <ng-select id="filter_defendant_id" class="ng-select-alternative" [items]="usuarioList" [multiple]="true" bindLabel="label" bindValue="id" placeholder="Todos os Demandados" formControlName="filter_defendant_id">
                    </ng-select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-4 m-b">
                    <label class="col-sm-12 pb-1">Solicitante</label>
                    <ng-select id="filter_demandant_id" class="ng-select-alternative" [items]="usuarioList" [multiple]="true" bindLabel="label" bindValue="id" placeholder="Todos os Solicitante" formControlName="filter_demandant_id">
                    </ng-select>
                  </div>
                  <div class="col-sm-4 m-b">
                    <label class="col-sm-12 pb-1">Situação</label>
                    <ng-select id="filter_status1_id" class="ng-select-alternative" [items]="situacaoList" bindLabel="label" bindValue="id" placeholder="Selecione a Situação" formControlName="filter_status1_id">
                    </ng-select>
                  </div>
                </div>
                <div class="form-group row d-flex justify-content-end">
                  <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
                    <button class="btn btn-primary btn" type="button" (click)="search()">Pesquisar</button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="system-table table-container">
            <div class="system-table-conteiner">
              <table>
                <thead>
                  <tr>
                    <th class="text-center">Código</th>
                    <th>Órgão Demandado</th>
                    <th>Item Monitorado</th>
                    <th>Título</th>
                    <th>Andamento</th>
                    <th class="text-center">Situação</th>
                    <th class="text-center">Prazo</th>
                    <th>Solicitante</th>
                    <th class="text-center">Alterado em</th>
                    <th class="text-center btn-icon-td">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let item of demandas; let i = index">
                    <tr>
                      <td class="title">{{item?.id}}</td>
                      <td>{{item?.agency_name}}</td>
                      <td>{{item?.monitored_item}}</td>
                      <td>{{item?.subject}}</td>
                      <td>{{item?.issue_sub_stat_name}}</td>
                      <td class="status">
                        <div>{{item?.issue_stat_name}}</div>
                        <div [innerHTML]="item?.status1"></div>
                      </td>
                      <td class="text-center">{{ item?.dt_foreseen_end }}</td>
                      <td>{{ item?.demandant_name }}</td>
                      <td class="text-center">{{ item?.ctr_dth_atu }}</td>
                      <td>
                        <div class="btn-icon">
                          <a class="icon-table m-b-sm" [routerLink]="view(item?.id)">
                            <img src="assets/images/svgs/lupa.svg" alt="Visualizar" tooltip="Visualizar" placement="bottom">
                          </a>
                          <span class="icon-table icon-table-text" (click)="alertMail(item)" *ngIf="item?.issue_stat_id">
                            <span tooltip="Enviar e-mail solicitando atenção" placement="bottom">Nova demanda</span>
                          </span>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                  <tr *ngIf="!demandas?.length" class="border-b-radius">
                    <td colspan="13" class="text-center">{{ !lengthDemandas ? 'Realize uma pesquisa para encontrar registros.' : 'Nenhum registro encontrado' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>